import { lazy } from "react";
import type { AppRouteObject } from "../../routes";

const ExportPage = lazy(() => import("../ExportPage"));

export const ExportRoute: AppRouteObject = {
  path: "/:realm/export",
  element: <ExportPage />,
  breadcrumb: (t) => t("titleUsers"),
  handle: {
    access: "query-users",
  },
};
